import React, { useState, useRef } from 'react';
import { Box, Button, Keyboard, TextInput } from 'grommet';
import styled from 'styled-components';
import { Search as SearchIcon } from 'grommet-icons';

const StyledTextInput = styled(TextInput).attrs(() => ({
    'aria-labelledby': 'search-icon-example',
}))``;

const Search = ({ size }) => {
    const [focused, setFocused] = useState(false);
    const inputRef = useRef();

    return (
        <>
            {!focused && ['xsmall', 'small'].includes(size) && (
                <Button
                    a11yTitle="Search"
                    icon={<SearchIcon />}
                    hoverIndicator
                    onClick={() => setFocused(true)}
                />
            )}
            {(focused || !['xsmall', 'small'].includes(size)) && (
                <Box background="background-contrast" round="xsmall" width="medium">
                    <Keyboard onEsc={() => setFocused(false)}>
                        <StyledTextInput
                            ref={inputRef}
                            icon={<SearchIcon id="search-icon-example" />}
                            dropHeight="small"
                            placeholder="Search"
                            onBlur={() => setFocused(false)}
                            plain
                            reverse
                        />
                    </Keyboard>
                </Box>
            )}
        </>
    )
}

export default Search;